import {
	type Jast,
	type Clause,
	type TerminalClause,
	CLAUSE_TYPE_COMPOUND,
	CLAUSE_TYPE_TERMINAL,
} from '@atlaskit/jql-ast';

const findClauseInAst = (ast: Jast, field: string): TerminalClause | undefined => {
	const where = ast.query?.where;

	if (where) {
		if (where.clauseType === CLAUSE_TYPE_COMPOUND) {
			const { clauses } = where;

			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			return clauses.find(
				(c: Clause) => c.clauseType === CLAUSE_TYPE_TERMINAL && c.field.value === field,
			) as TerminalClause | undefined;
		}

		if (where.clauseType === CLAUSE_TYPE_TERMINAL && where.field.value === field) {
			return where;
		}
	}
	return undefined;
};

export default findClauseInAst;
